import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import Tabs from 'src/components/atoms/tabs/tabs';
import { TTab } from 'src/components/atoms/tabs/tabs.model';
import { User } from 'src/models/user.model';
import { UserForm } from './employeeDetailsTabs/userForm';
import styles from './employes.module.scss';
import { Anagraphic } from './employeeDetailsTabs/anagraphic/anagraphic';
import { Heading } from '../../atoms/heading/heading';
import Flex from '../../atoms/flex/flex';

export const EmployeeDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state as User;

  const tabs: TTab[] = [
    { label: 'Utente', value: 'USER' },
    { label: 'Anagrafica', value: 'ANAGRAPHIC' },
  ];

  const [currentTab, setCurrentTab] = useState<TTab>(tabs[0]);

  const onBackButtonClick = () => {
    navigate('/');
    navigate('/employees');
  };

  return (
    <div className="container sm m-auto">
      <Flex container alignItems="center" gap={10} className="mt-1 mb-1">
        <Button size="sm" color="white" mode="outline" rounded="rounded-md" className={styles.backButton} onClick={onBackButtonClick}>
          Indietro
        </Button>
        <Heading content={user.anagraphic ? `${user?.anagraphic?.firstname} ${user?.anagraphic?.lastname}` : user.email} size={2} />
        <div className="ml-auto">
          <Tabs>
            {tabs.map(tab => (
              <Tabs.Item key={tab.value} tab={tab} currentTab={currentTab} onChange={() => setCurrentTab(tab)}>
                {tab.label}
              </Tabs.Item>
            ))}
          </Tabs>
        </div>
      </Flex>

      <div className={styles.tabBody}>
        {currentTab.value === 'USER' && <UserForm />}
        {currentTab.value === 'ANAGRAPHIC' && <Anagraphic />}
      </div>
    </div>
  );
};
